export enum AUTH_ACTION_TYPE {
  LOGIN_BY_EMAIL = 'auth/loginByEmail',
  LOGOUT = 'auth/logout',
  PASSWORD_FORGOT = 'auth/password/forgot',
  PASSWORD_RESET = 'auth/password/reset',
}
